/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2020-11-06 20:40:06
 * @LastEditors: voanit
 * @LastEditTime: 2022-01-05 10:26:25
 */
import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'

export function getToken() {
  return Cookies.get(TokenKey) || window.nm?.token() || ''
}

export function setToken(token) {
  //validation_token接口返回当前用户的权限code-Array
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setMyToken(token) {
  //validation_token接口返回的token
  return Cookies.set('long-token', token)
}
export function getMyToken() {
  return Cookies.get('long-token')
}
export function removeMyToken() {
  return Cookies.remove('long-token')
}

export function getUnify() {
  //统一登录接口返回的token
  return Cookies.get('unify')
}
export function setUnify(token) {
  //统一登录接口返回的token
  return Cookies.set('unify', token)
}

export function removeUnify() {
  Cookies.remove('unify')
  return Cookies.remove('unify', { path: '/', domain: '.puxinwangxiao.com' })
}
const UserRoles = 'UserRoles'
export function getUserRoles() {
  return localStorage.getItem(UserRoles)
}

export function setUserRoles(roles) {
  return localStorage.setItem(UserRoles, JSON.stringify(roles))
}

export function removeUserRoles() {
  return localStorage.removeItem(UserRoles)
}

const ChargerKey = 'Charger'
export function getCharger() {
  return Cookies.get(ChargerKey)
}

export function setCharger(charger) {
  return Cookies.set(ChargerKey, charger)
}

export function removeCharger() {
  return Cookies.remove(ChargerKey)
}
